export const encodeURLValues = (input) => Object.keys(input).map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(input[key])}`).join('&');

export const decodeFrontendURL = (input) => new URL(`http://h${new URL(input).hash.replace('#', '')}`);

export const decodeURLValues = (input) => {
  const { search } = decodeFrontendURL(input);
  const params = new URLSearchParams(search);
  return Array.from(params.entries()).reduce((res, cur) => ({ ...res, [cur[0]]: cur[1] }), {});
};
